<template>
  <div
    tabindex="-1"
    role="dialog"
    class="modal-side-drawer-filters fade fixed-end op"
  >
    <div
      role="document"
      class="modal-dialog modal-dialog-vertical dw-md-8 dw-lg-6 dw-xl-5"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h2 class="modal-title">Advanced Search</h2>
          <button
            type="button"
            data-bs-dismiss="modal"
            aria-label="Close"
            class="close"
          >
            <span aria-hidden="true"><i class="far fa-times"></i></span>
          </button>
        </div>
        <div class="modal-body" v-if="__initialized">
          <div class="data-filters">
            <div class="row">
              <div class="col-12 col-lg-6">
                <label>Search</label>
                <div class="input-group">
                  <span class="input-group-text">
                    <i class="fal fa-search"></i>
                  </span>
                  <input type="text" class="form-control" placeholder="Find project or client" :value="filters.search" @input="updateSearch"/>
                </div>
              </div>

              <div class="col-6 col-lg-4">
                <label>Sort</label>
                <div class="input-group">
                  <span class="input-group-text">
                    <i class="fal fa-sort-amount-down"></i>
                  </span>

                  <multiselect
                    :options="sortByOptions"
                    :show-labels="false"
                    :allow-empty="false"
                    placeholder
                    v-model="sortBy"
                    label="name"
                  />
                </div>
              </div>

              <div class="col-6 col-lg-2 d-flex align-items-end">
                <div class="form-check mb-2">
                  <input id="budgets-filter-archived" type="checkbox" class="form-check-input" v-model="showArchived" />
                  <label class="form-check-label" for="budgets-filter-archived">Archived</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useQueryParamFilters } from '@codium/codium-vue'
import { debounce } from 'lodash'

export default {
  mixins: [useQueryParamFilters()],

  data () {
    return {
      filters: {
        search: null,
        sort: 'Newest',
        archived: null
      },
      sortByOptions: [
        { name: 'Newest First', key: 'Newest' },
        { name: 'Oldest First', key: 'Oldest' },
        { name: 'A-Z', key: 'A - Z' },
        { name: 'Z-A', key: 'Z - A' }
      ]
    }
  },

  computed: {
    sortBy: {
      get () {
        return this.sortByOptions.find(({ key }) => key === this.filters.sort)
      },

      set (value) {
        this.filters.sort = value.key
      }
    },

    showArchived: {
      get () {
        return this.filters.archived === 'true'
      },

      set (value) {
        this.filters.archived = value ? 'true' : null
      }
    }
  },

  methods: {
    updateSearch: debounce(function (event) {
      this.filters.search = event.target.value
    }, 750)
  },

  watch: {
    queryParams: {
      handler (params) {
        this.$emit('input', params)
      },
      immediate: true
    }
  }
}
</script>
